import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';
import {
  FieldErrors,
  FieldValues,
  FormProvider,
  UseFormReturn,
} from 'react-hook-form';
import Swal from 'sweetalert2';

interface FormContainerProps<TForm extends FieldValues>
  extends PropsWithChildren {
  readonly onSubmit?: (data: TForm) => void;
  readonly form: UseFormReturn<TForm>;
  readonly className?: string;
}

interface FormFooterProps extends PropsWithChildren {
  className?: string;
}

export const FormContainer = <TForm extends FieldValues>({
  children,
  form,
  onSubmit,
  className = '',
}: FormContainerProps<TForm>) => {
  const onError = (errors: FieldErrors) => {
    console.error(errors);
    const errorMessages = Object.entries(errors)
      .map(([field, error]) => `${field}: ${error?.message || 'Required'}`)
      .join('<br>');

    Swal.fire({
      icon: 'error',
      title: 'Form Submission Error',
      html: errorMessages,
    });
  };

  return (
    <FormProvider {...form}>
      <form
        className={className}
        onSubmit={onSubmit ? form.handleSubmit(onSubmit, onError) : () => {}}
      >
        {children}
      </form>
    </FormProvider>
  );
};

export const FormFooter: React.FC<FormFooterProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-row justify-start gap-3 mt-5',
        className,
      )}
    >
      {children}
    </div>
  );
};
